export const ROOT_DOMAIN_HOST = "workscope.app";
export const ROOT_DOMAIN_WWW_HOST = "www.workscope.app";
export const DASHBOARD_DOMAIN_HOST = "dashboard.workscope.app";

const INDEXABLE_PUBLIC_PATHS = new Set([
  "/",
  "/pricing",
  "/affiliate",
  "/privacy",
  "/terms",
  "/sms-consent",
  "/sms-opt-in-proof",
]);

export function isRootHost(hostname: string) {
  return hostname === ROOT_DOMAIN_HOST || hostname === ROOT_DOMAIN_WWW_HOST;
}

export function isDashboardHost(hostname: string) {
  return hostname === DASHBOARD_DOMAIN_HOST;
}

export function isIndexablePublicPath(pathname: string) {
  return INDEXABLE_PUBLIC_PATHS.has(pathname);
}

export function shouldIndexRoute(hostname: string, pathname: string) {
  return isRootHost(hostname) && isIndexablePublicPath(pathname);
}

export function getCanonicalUrlForRoute(hostname: string, pathname: string) {
  if (!shouldIndexRoute(hostname, pathname)) return null;
  const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  return `https://${ROOT_DOMAIN_HOST}${normalizedPath}`;
}

export function getRobotsContentForRoute(hostname: string, pathname: string) {
  return shouldIndexRoute(hostname, pathname)
    ? "index,follow"
    : "noindex,nofollow,noarchive,nosnippet";
}
